import React from "react";
import { navigate } from "gatsby";

import GatedArticle from "~/components/GatedArticle";

import { setLocalStorageItem } from "~/utilities/localStorageHelpers";

const ArticleGatedArticle = ({ data, location }) => {
    const {
        wpArticle: { title, productLines, details, translationGroupId },
    } = data;

    const runOnSubmitActions = {
        saveToLocalStorage: {
            key: `kc-${translationGroupId}`,
            value: "completed",
        },
        navigate: {
            label: title,
            url: location.pathname,
        },
    };

    const runOnSubmit = () => {
        setLocalStorageItem(
            runOnSubmitActions.saveToLocalStorage.key,
            runOnSubmitActions.saveToLocalStorage.value,
        );
        navigate("?completed=true");
    };

    return (
        <GatedArticle
            runOnSubmit={runOnSubmit}
            runOnSubmitActions={runOnSubmitActions}
            productLine={productLines?.nodes[0]?.slug}
            copy={details.gatedPreviewCopy}
            overrideFormId={details.overrideFormId}
        />
    );
};

export default ArticleGatedArticle;
